import { gql } from "@apollo/client";

export const GET_GRILLA_CONEXIONES_DETALLE = gql`
query detalleConexiones($input: ConexionDetalleInput!) {
  detalleConexiones(input: $input) {
    success,
    error,
    valorEsperado {
      idEvaluacion,
      idIndicacion,
      planTipo,
      numeroDia,
      dia,
      fecha,
      idConexion,
      idEstado,
      estadoAbreviacion,
      estado
    }
  }
}`;


const adaptDetalleConexionRow = (conexion) => {
  return {
    idEvaluacion: conexion?.idEvaluacion,
    idIndicacion: conexion?.idIndicacion,
    planTipo: conexion?.planTipo,
    numeroDia: conexion?.numeroDia,
    dia: conexion?.dia,
    fecha: conexion?.fecha,
    idConexion: conexion?.idConexion,
    idEstado: conexion?.idEstado,
    estadoAbreviacion: conexion?.estadoAbreviacion,
    estado: conexion?.estado
  };
};

export const adaptDetalleConexionesArray = (conexiones) => {
  return (
    structuredClone(
      conexiones?.detalleConexiones?.valorEsperado
    )?.map((conexion) => adaptDetalleConexionRow(conexion)) || []);

};